$(document).ready(function () {
    if ($('.to-section').length <= 1) {
        $('[data-db-target-for="tocSections"]').parent('li').remove();
        $('.toc-go-section').remove();
    }
});

$(window).on('load resize orientationchange', function () {
    // if Pb is open no content truncation should take effect
    var isNotPb = $('#pb-editor [data-pb-dropzone]').length === 0,
        toTrunk8 = null;

    if (isNotPb) {
        toTrunk8 = $('.aboutBook');

        if (toTrunk8.find('.pb-rich-text').length) {
            toTrunk8 = toTrunk8.find('.pb-rich-text');
        }

        toTrunk8.truncate({
            lines: 5,
            seeMoreLink: true,
            seeMoreText: 'Show all',
            seeLessText: 'Show less',
        });
    }
});

document.addEventListener('mathjax-initilized', () => {
    setTimeout(() => {
        UX.utils.fallbackImageViewer();
    }, 1000);
});

UX.utils.lazyFallbackImage();
